import axios from "axios";

const state = {
    clients: [],
    addclient: {},
    addproject: {},
    projects: [],
    clientproject: [],
    projectproduct: [],
    saveproduct: {},
};

const getters = {
    clients: (state) => state.clients,
    addclient: (state) => state.addclient,
    addproject: (state) => state.addproject,
    projects: (state) => state.projects,
    clientproject: (state) => state.clientproject,
    projectproduct: (state) => state.projectproduct,
    saveproduct: (state) => state.saveproduct,
};

const actions = {
    AddClient({ commit }, { form }) {
        return form.post(`/shop/api/project/addclient`).then((response) => {
            commit("ADD_CLIENT", response.data);

            return response;
        });
    },

    EditClient({ commit }, { form }) {
        return form.post(`/shop/api/project/editclient`).then((response) => {
            commit("ADD_CLIENT", response.data);

            return response;
        });
    },

    LoadClient({ commit }, customer_id) {
        return axios
            .get(`/shop/api/project/clients/${customer_id}`)
            .then((response) => {
                commit("LOAD_CLIENTS", response.data);

                return response;
            });
    },

    DeleteClient({ commit }, client_id) {
        return axios
            .get(`/shop/api/project/deleteclient/${client_id}`)
            .then((response) => {
                commit("LOAD_CLIENTS", response.data);

                return response;
            });
    },

    AddProject({ commit }, { form }) {
        return form.post(`/shop/api/project/addproject`).then((response) => {
            commit("ADD_PROJECT", response.data);

            return response;
        });
    },
    EditProject({ commit }, { form }) {
        return form.post(`/shop/api/project/editproject`).then((response) => {
            commit("ADD_PROJECT", response.data);

            return response;
        });
    },

    DeleteProject({ commit }, project_id) {
        return axios
            .get(`/shop/api/project/deleteproject/${project_id}`)
            .then((response) => {
                commit("LOAD_PROJECTS", response.data);

                return response;
            });
    },
    DeleteProduct({ commit }, product_id) {
        return axios
            .get(`/shop/api/project/deleteproduct/${product_id}`)
            .then((response) => {
                commit("LOAD_PROJECTS", response.data);

                return response;
            });
    },

    AddClientAndProject({ commit }, { form }) {
        return form
            .post(`/shop/api/project/addclientandproject`)
            .then((response) => {
                commit("ADD_PROJECT", response.data);

                return response;
            });
    },

    AddProductToProject({ commit }, { form }) {
        return form
            .post(`/shop/api/project/addproducttoproject`)
            .then((response) => {
                commit("ADD_PROJECT", response.data);

                return response;
            });
    },

    LoadClientProjects({ commit }, client_id) {
        return axios.get(`/shop/api/projects/${client_id}`).then((response) => {
            commit("LOAD_PROJECTS", response.data);

            return response;
        });
    },

    LoadClientAndProject({ commit }, customer_id) {
        return axios
            .get(`/shop/api/project/clientproject/${customer_id}`)
            .then((response) => {
                commit("LOAD_CLIENTS_PROJECTS", response.data);

                return response;
            });
    },

    LoadProjectProduct({ commit }, client_id) {
        return axios
            .get(`/shop/api/project/projectproduct/${client_id}`)
            .then((response) => {
                commit("LOAD_PROJECT_PRODUCT", response.data);

                return response;
            });
    },
    saveProduct({ commit }, { product_id, notes, qty }) {
        return axios
            .get(`/shop/api/project/saveproduct/${product_id}/${notes}/${qty}`)
            .then((response) => {
                commit("SAVE_PRODUCT", response.data);

                return response;
            });
    },
    saveProductBaseFabric({ commit }, { product_id, basefabric, basestyle }) {
        return axios
            .get(`/shop/api/project/saveproductbasefabric/${product_id}/${basefabric}/${basestyle}`)
            .then((response) => {
                return response;
            });
    },
    saveProductBaseFabricOnCart({ commit }, { product_id, itemid, basefabric, basestyle }) {
        return axios.get(`/shop/api/cart/saveproductbasefabric/${product_id}/${itemid}/${basefabric}/${basestyle}`)
            .then((response) => {
                return response;
            });
    },

    checkoutProduct({ commit }, { user_id, product_id }) {
        return axios
            .get(`/shop/api/project/checkoutproduct/${user_id}/${product_id}`)
            .then((response) => {
                commit("SAVE_PRODUCT", response.data);

                return response;
            });
    },

    loadProjectPDF({ commit }, { project_id, customer_id }) {
        return axios
            .get(`/shop/api/project/pdf/${project_id}/${customer_id}`, {
                responseType: "blob",
            })
            .then((response) => {
                return response;
            });
    },
    loadProjectPDFURL({ commit }, { project_id, customer_id }) {
        return axios
            .get(`/shop/api/project/pdf/url/${project_id}/${customer_id}`)
            .then((response) => {
                return response;
            });
    },
};

const mutations = {
    ADD_CLIENT: (state, data) => {
        state.addclient = data;
    },

    LOAD_CLIENTS: (state, data) => {
        state.clients = data;
    },

    ADD_PROJECT: (state, data) => {
        state.addproject = data;
    },

    LOAD_PROJECTS: (state, data) => {
        state.projects = data;
    },

    LOAD_CLIENTS_PROJECTS: (state, data) => {
        state.clientproject = data;
    },

    LOAD_PROJECT_PRODUCT: (state, data) => {
        state.projectproduct = data;
    },

    SAVE_PRODUCT: (state, data) => {
        state.saveproduct = data;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
